import { Button, Grid, TextAreaField, TextField } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import LocalizedStrings from "react-localization";
import { useContext } from "react";
import SquareIcon from "@mui/icons-material/Square";
import { HexColorPicker } from "react-colorful";

import { ScheduleContext } from "components/maintenanceSchedules/context/ScheduleContext";
import CustomPopover from "components/utils/CustomPopover";

const GeneralDataCard = ({ serviceOrder }) => {
  const { updateEvent } = useContext(ScheduleContext);

  const onChange = (e) => {
    const { name, value } = e.target;
    updateEvent({ id: serviceOrder.id, [name]: value });
  };

  const onChangeColor = (color) => {
    updateEvent({ id: serviceOrder.id, color });
  };

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5 text-muted">{strings.general.generalData}</span>
        <TextField
          name="color"
          label={strings.general.color}
          value={serviceOrder.color || ""}
          onChange={onChange}
          outerEndComponent={
            <CustomPopover
              content={
                <HexColorPicker
                  style={{ margin: "20px" }}
                  color={serviceOrder.color || "#14547b"}
                  onChange={onChangeColor}
                />
              }
            >
              <Button color={serviceOrder.color || "#14547b"}>
                <SquareIcon />
              </Button>
            </CustomPopover>
          }
        ></TextField>
        <TextAreaField
          name="observations"
          label={strings.general.observations}
          value={serviceOrder.observations || ""}
          onChange={onChange}
        ></TextAreaField>
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    general: {
      generalData: "Datos generales",
      color: "Color",
      observations: "Observaciones",
    },
  },
});

export default GeneralDataCard;
